import { QuestionTypes } from '@showbie-socrative/socrative-utils';

import { QuestionTypes as AnalyticsQuestionTypes } from '~analytics/types';
import { QuizQuestion } from '~teacher/models/quizzes';

import { Question } from '../../api/responses';
import { sendQuestionSavedEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class QuestionSavedEventAdapter extends EventAdapter {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = sendQuestionSavedEvent;

  constructor(props: {
    originalQuestion: QuizQuestion | null;
    modifiedQuestion: Question;
  }) {
    super();

    try {
      this.eventData = {
        is_new_question: props.originalQuestion === null,
        question_type: this.mapQuestionType(props.modifiedQuestion.type),
        original_question_weight: props.originalQuestion?.gradingWeight,
        saved_question_weight: props.modifiedQuestion.gradingWeight,
        original_has_explanation_image: !!props.originalQuestion
          ?.explanationImage,
        saved_has_explanation_image: !!props.modifiedQuestion.explanationImage,
        original_has_question_image: !!props.originalQuestion?.questionImage,
        saved_has_question_image: !!props.modifiedQuestion.questionImage,
        original_answer_count: props.originalQuestion?.answers?.length ?? 0,
        saved_answer_count: props.modifiedQuestion.answers.length,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }

  mapQuestionType(questionType: QuestionTypes | string) {
    switch (questionType) {
      case QuestionTypes.TrueFalse:
        return AnalyticsQuestionTypes.TrueFalse;
      case QuestionTypes.MultipleChoice:
        return AnalyticsQuestionTypes.MultipleChoice;
      case QuestionTypes.FreeResponse:
        return AnalyticsQuestionTypes.ShortAnswer;
      default:
        return null;
    }
  }
}
